import type {CryptoNetwork} from './types';

const absurd = (x: never): never => {
  throw new Error(`Unexpected value: ${JSON.stringify(x)} -> ${typeof x}`);
};

export const getExplorerUrlForTransaction = ({
  network,
  mainnet,
  blockchainTxId,
}: {
  network: CryptoNetwork;
  mainnet: boolean;
  blockchainTxId: string;
}): `https://${string}` | null => {
  if (!blockchainTxId) {
    return null;
  }

  switch (network) {
    case 'arbitrum':
      return mainnet
        ? `https://arbiscan.io/tx/${blockchainTxId}`
        : `https://sepolia.arbiscan.io/tx/${blockchainTxId}`;
    case 'avalanche_c_chain':
      return mainnet
        ? `https://snowtrace.io/tx/${blockchainTxId}`
        : `https://testnet.snowtrace.io/tx/${blockchainTxId}`;
    case 'base':
      return mainnet
        ? `https://basescan.org/tx/${blockchainTxId}`
        : `https://sepolia.basescan.org/tx/${blockchainTxId}`;
    case 'bitcoin':
      return mainnet
        ? `https://www.blockchain.com/explorer/transactions/btc/${blockchainTxId}`
        : `https://mempool.space/testnet/tx/${blockchainTxId}`;
    case 'ethereum':
      return mainnet
        ? `https://etherscan.io/tx/${blockchainTxId}`
        : `https://sepolia.etherscan.io/tx/${blockchainTxId}`;
    case 'optimism':
      return mainnet
        ? `https://optimistic.etherscan.io/tx/${blockchainTxId}`
        : `https://sepolia-optimism.etherscan.io/tx/${blockchainTxId}`;
    case 'polygon':
      return mainnet
        ? `https://polygonscan.com/tx/${blockchainTxId}`
        : `https://amoy.polygonscan.com/tx/${blockchainTxId}`;
    case 'solana':
      return mainnet
        ? `https://solscan.io/tx/${blockchainTxId}`
        : `https://solscan.io/tx/${blockchainTxId}?cluster=devnet`;
    case 'stellar':
      return mainnet
        ? `https://stellarchain.io/transactions/${blockchainTxId}`
        : `https://testnet.stellarchain.io/transactions/${blockchainTxId}`;
    case 'sui':
      return mainnet
        ? `https://suiscan.xyz/mainnet/tx/${blockchainTxId}`
        : `https://suiscan.xyz/testnet/tx/${blockchainTxId}`;
    case 'tempo':
      return mainnet
        ? `https://explore.tempo.xyz/receipt/${blockchainTxId}`
        : `https://explore.testnet.tempo.xyz/receipt/${blockchainTxId}`;
    case 'tron':
      return mainnet
        ? `https://tronscan.org/#/transaction/${blockchainTxId}`
        : `https://nile.tronscan.org/#/transaction/${blockchainTxId}`;
    default:
      return absurd(network);
  }
};
